<mat-card>
    <mat-card-title style="text-align:center;">{{message}}</mat-card-title>
    <!-- <h2 align="center">{{message}}</h2> -->
    <br>
    <div class="container">
        <div class="row">
            <div>
                <mat-form-field>
                    <mat-placeholder>Crossholding Indicator Code</mat-placeholder>
                    <input matInput type="text" id="aum_code" [(ngModel)]="code" #aumcode="ngModel" [readonly]="isReadOnly" (input)="change($event)">
                </mat-form-field>
            </div>
            <div>
                <mat-form-field>
                    <mat-placeholder>Crossholding Indicator Name</mat-placeholder>
                    <input matInput type="text" [value]="name" id="aum_dim_name" [(ngModel)]="name" #aumname="ngModel" (input)="change($event)">
                </mat-form-field>
            </div>
            <div>
                <mat-form-field>
                    <mat-placeholder>Crossholding Indicator Description</mat-placeholder>
                    <input matInput type="text" [value]="desc" id="aum_dim_desc" [(ngModel)]="desc" #aumdesc="ngModel" (input)="change($event)">
                </mat-form-field>
            </div>
            <div class="col-12" [hidden]="true">
                <mat-form-field appearance="fill">
                    <mat-label>Crossholding Indicator Include in MPAR extract</mat-label>
                    <mat-select [(value)]="mpar"  [disabled]="isDisabled">
                        <mat-option value="Yes" > Yes </mat-option>
                        <mat-option value="No"> No </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-error *ngIf="mparControl.hasError('required')">
                    This field is required
                </mat-error>               
            </div>
        </div>
        <div class="row">
            <div class="col-12 ">
                <button mat-button class="mat-raised-button mat-primary float-right btn-dialog" cdkFocusInitial
                [disabled]="(!aumcode.touched && !aumname.touched && !aumdesc.touched)" (click)="SaveAttributes()">Save</button>
                <button mat-button class="mat-stroked-button float-right btn-dialog " color="primary"
                    (click)="onNoClick()">Cancel</button>
            </div>
        </div>
    </div>
</mat-card>